import StorageNotAvailableException from '@naturehouse/nh-essentials/lib/exceptions/StorageNotAvailableException';
import {
    addToLocalStorage,
    getValueFromLocalStorage
} from '@naturehouse/nh-essentials/lib/localStorage/localStorage';

export const USER_AVAILABLE_CLASSNAME = 'userAvailable';

export const USER_IS_LANDLORD_CLASSNAME = 'userIsLandlord';

export class UserStateStore {
    private readonly IS_LANDLORD_KEY: string = 'll';

    private readonly IS_LOGGED_IN: string = 'li';

    public constructor() {
        window.addEventListener('storage', this.#handleStorageEvent);
    }

    get isLandlord(): boolean {
        return this.#validateValueFromLocalStorage(this.IS_LANDLORD_KEY);
    }

    set isLandlord(value: boolean) {
        this.#addToLocalStorage(this.IS_LANDLORD_KEY, value);
        this.#setIsLandlordClassName();
    }

    get isLoggedIn(): boolean {
        return this.#validateValueFromLocalStorage(this.IS_LOGGED_IN);
    }

    set isLoggedIn(value: boolean) {
        this.#addToLocalStorage(this.IS_LOGGED_IN, value);
        this.#setIsUserClassName();
    }

    public resetState(): void {
        this.isLandlord = false;
        this.isLoggedIn = false;
    }

    #validateValueFromLocalStorage(key: string): boolean {
        try {
            return getValueFromLocalStorage(key) === 'true';
        } catch (error) {
            if (error instanceof StorageNotAvailableException) {
                return false;
            }

            throw error;
        }
    }

    #addToLocalStorage(key: string, value: boolean): void {
        try {
            addToLocalStorage(key, value.toString());
        } catch (error) {
            if (error instanceof StorageNotAvailableException) {
                return;
            }

            throw error;
        }
    }

    #setIsLandlordClassName(): void {
        document.body.classList.toggle(USER_IS_LANDLORD_CLASSNAME, this.isLandlord);
    }

    #setIsUserClassName(): void {
        document.body.classList.toggle(USER_AVAILABLE_CLASSNAME, this.isLoggedIn);
    }

    readonly #handleStorageEvent = (event: StorageEvent): void => {
        if (event.key === this.IS_LANDLORD_KEY) {
            this.#setIsLandlordClassName();
        }

        if (event.key === this.IS_LOGGED_IN) {
            this.#setIsUserClassName();
        }
    };
}

export default new UserStateStore();
